import { styled } from "../../../styled-system/jsx";

const Pill = styled("span", {
  base: {
    display: "inline-block",
    padding: "2px 8px",
    borderRadius: "12px",
    fontSize: "10px",
    fontWeight: "500",
    backgroundColor: "#e5e7eb",
    color: "#374151",
    marginRight: "6px",
    textTransform: "uppercase",
  },
  variants: {
    variant: {
      info: {
        backgroundColor: "mauve.300",
        color: "royalPurple",
      },
      warning: {
        backgroundColor: "yellow.300",
        color: "yellow.700",
      },
      error: {
        backgroundColor: "fuchsia.300",
        color: "fuchsia.700",
      },
      success: {
        backgroundColor: "green.300",
        color: "green.700",
      },
    },
  },
});

export default Pill;
